<template>
    <div>
        <div class="col1">
            <Messages  />
        </div>
        
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import { currentUser, zipcodesCollection } from '../firebaseConfig'
    import moment from 'moment'
    const fb = require('../firebaseConfig.js')
    import Messages from './Messages'
    export default {
        components: {
            Messages
            },
        computed: {
            ...mapState(['userProfile', 'currentUser'])
        },
        
    }
</script>